export default {
    components: {

    },
    filters: {
    },
    data() {
        return {
            columnIncomeShowList: [
                {
                    value: "total",
                    name: "加總"
                },
                {
                    value: "atmTotal",
                    name: "銀行匯款總額"
                },
                {
                    value: "cashTotal",
                    name: "現金總額"
                },
                {
                    value: "creditTotal",
                    name: "線上刷卡總額"
                },
                {
                    value: "depositTotal",
                    name: "儲值金抵扣總額"
                },
                {
                    value: "prepaidTotal",
                    name: `${this.$t('prepaid.BASE')}抵扣總額`
                },
                {
                    value: "storeCreditTotal",
                    name: "現場刷卡總額"
                },
                {
                    value: "storeLinePayTotal",
                    name: "Line Pay付款總額"
                },
                {
                    value: "chaileaseTotal",
                    name: "中租付款總額"
                },
                {
                    value: "vaccTotal",
                    name: "虛擬帳戶匯款總額"
                },
                {
                    value: "installmentTotal",
                    name: "分期付款總額"
                },
                {
                    value: "orders",
                    name: "數量"
                },
            ],
            forShowColumnInSelect: 'total', // 要顯示什麼數據
            showMode: 'total',
        }
    },
    computed: {
        /**
         * @description 過濾掉付款方式
         */
        columnIncomeShowListForModule(){
            let list = JSON.parse(JSON.stringify(this.columnIncomeShowList))
            // 如果沒有儲值金方案，則filter掉depositTotal
            if(!this.$hasDeposit()){
                list = list.filter(item => item.value !== 'depositTotal')
            }
            // 如果沒有開通線上金流，則filter線上系列
            if(!this.$cashFlowSettingPass()){
                list = list.filter(item => item.value !== 'creditTotal' && item.value !== 'vaccTotal')
            }
            // 目前僅自燃派開放中租，其他店家filter中租
            if(this.$store.state.merchant.cached.alias !== 'naturalpan') {
                list = list.filter(item => item.value !== 'chaileaseTotal')
            }
            return list
        }
    },
    watch: {

    },
    created() {

    },
    methods: {
        showColumnName() {
            const { name } = this.columnIncomeShowList.find(item => item.value === this.forShowColumnInSelect)
            return name
        },
        changeShowMode() {
            this.forShowColumnInSelect = this.showMode === 'total' ? 'total' : 'orders'
        },
        showColumnType() {
            this.showMode = this.forShowColumnInSelect === 'orders' ? 'orders' : 'total'
        },
    }
}